<template>
  <div class="procard_wrap">
    <div class="procard_content">
      <div class="content_left">
        <div class="left_tit">{{ $t('productionBrain.organizationCarbon.procard.title') }}</div>
        <div class="left_icon_wrap">
          <div
            class="icon_item"
            v-for="(item, index) in procardImgList"
            :key="index"
            ref="iconItem"
          >
            <span>{{ item.txt }}</span>
          </div>
        </div>
      </div>
      <div class="content_right">
        <img :src="procardImg" class="responsive-img" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProCard',
  data() {
    return {
      activeIndex: 0,
      procardImg: require('@/assets/img/carbon/组织碳流程图.png'),
      procardImgList: [
        {
          txt: this.$t('productionBrain.organizationCarbon.procard.features.simplified'),
        },
        {
          txt: this.$t('productionBrain.organizationCarbon.procard.features.intelligent'),
        },
        {
          txt: this.$t('productionBrain.organizationCarbon.procard.features.efficient'),
        },
      ],
    }
  },
  props: {
    procardList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    '$i18n.locale': {
      handler: 'updateData',
      immediate: true
    }
  },
  methods: {
    updateData() {
      this.procardImgList = [
        {
          txt: this.$t('productionBrain.organizationCarbon.procard.features.simplified'),
        },
        {
          txt: this.$t('productionBrain.organizationCarbon.procard.features.intelligent'),
        },
        {
          txt: this.$t('productionBrain.organizationCarbon.procard.features.efficient'),
        },
      ];
    }
  }
}
</script>

<style lang="scss" scoped>
.procard_wrap {
  width: 70%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;
  @media screen and (max-width: 768px) {
    width: 95%;
    background: #f7f7f7;
  }
  .procard_btn {
    width: 100%;
    display: flex;
    .procard_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        height: 60px;
        text-align: center;
        font-size: 12px;
      }
    }
    .active {
      color: #fff;
      background: #2091d3;
      font-weight: bold;
      &::before {
        content: '▲';
        position: absolute;
        color: #2091d3;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
  }
  .procard_content {
    width: 100%;
    display: flex;
    padding: 30px 0px;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
    .content_left {
      width: 50%;
      background-color: #f2f7ff;
      padding: 20px;
      border-radius: 20px;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
      .left_tit {
        color: #2d3937;
        font-size: 17px;
        min-height: 90px;
        line-height: 2rem;
        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          padding: 10px 20px;
          color: #646464;
        }
      }
      .left_icon_wrap {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        padding-bottom: 30px;
        @media screen and (max-width: 768px) {
          justify-content: space-around;
        }
        .icon_item {
          width: 30%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #FFFFFF;
          box-shadow: 10px 10px 20px rgba($color: #000000, $alpha: 0.1);
          padding: 5px;
          box-sizing: content-box;
          cursor: pointer;
          &:nth-child(n + 4) {
            margin-top: 1rem;
          }
          @media screen and (max-width: 768px) {
            height: 50px;
            justify-content: center;
          }
          i {
            color: #7bbde3;
            font-size: 24px;
            @media screen and (max-width: 768px) {
              font-size: 20px;
            }
          }
          span {
            color: #646464;
            font-size: 16px;
            padding: 0 10px;
            @media screen and (max-width: 768px) {
              font-size: 14px;
            }
          }
        }
      }
      .left_btn {
        width: 180px;
        height: 50px;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
      }
    }
    .content_right {
      width: 50%;
      margin-left: 10px;
      @media screen and (max-width: 768px) {
        width: 100%;
        text-align: center;
      }
      text-align: right;
      .responsive-img {
        width: 120%; /* 默认宽度为 PC 端的 160% */
      }

      /* 移动端样式 */
      @media screen and (max-width: 768px) {
        .responsive-img {
          width: 100%; /* 在移动端宽度为 100% */
        }
      }

      .left_btn {
        width: 180px;
        height: 50px;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
        @media screen and (max-width: 768px) {
          width: 90px;
          height: 35px;
          font-size: 14px;
          border-radius: 20px;
          margin: 20px auto;
        }
      }
    }
  }
}
</style>